import classNames from 'classnames';
import { CSSProperties, FC } from 'react';

import styles from './styles.module.less';

interface ButtonProps {
  type?: 'default' | 'success' | 'info';
  size?: 'small' | 'normal' | 'large';
  border?: boolean;
  children?: React.ReactNode;
  block?: boolean;
  circle?: boolean;
  onClick?: () => void;
  color?: string;
  disabled?: boolean;
  htmlType?: 'button' | 'reset' | 'submit';
  style?: CSSProperties;
  className?: string;
}

const Button: FC<ButtonProps> = ({
  color,
  disabled = false,
  block = false,
  circle,
  size,
  type,
  htmlType = 'button',
  children,
  border,
  style,
  className,
  onClick
}) => {
  function createRipple(event) {
    const button = event.currentTarget;

    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${radius}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - diameter}px`;
    circle.classList.add(styles.ripple);

    const ripple = button.querySelector(`.${styles.ripple}`);

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  }
  const newstyle = color
    ? {
        ...style,
        background: color
      }
    : {
        ...style
      };

  return (
    <button
      disabled={disabled}
      style={newstyle}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        createRipple(e);
        onClick?.();
      }}
      className={classNames(styles.btn, {
        [styles.disabled]: disabled,
        [styles.block]: block,
        [styles.small]: size === 'small',
        [styles.large]: size === 'large',
        [styles.success]: type === 'success',
        [styles.info]: type === 'info',
        [styles.circle]: circle,
        [styles.border]: border,
        [className as string]: className
      })}
      type={htmlType}
    >
      {children}
    </button>
  );
};

export default Button;
